import { Fragment } from 'react';
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import useModals from '../../hooks/useModals';
import useConsole from '../../hooks/useConsole';
import useUrlParams from '../../hooks/useUrlParams';
import useDashboard from '../../hooks/useDashboard';
import { ConsoleSvg, PinnedSvg } from '../../../command_center/components/header/Svgs';

const RightContainer = () => {
    const { scenario_id, mission_id } = useUrlParams();
    const { get_modal_details, open_modal } = useModals();
    const { getFilterOptions } = useConsole();
    const { selected_element } = useDashboard();
    const { trueTwinId, elementId } = selected_element || {};

    const handleOpenConsole = () => {
        open_modal('generic_simulator_console');
        if (trueTwinId && scenario_id && elementId && mission_id) {
            getFilterOptions(trueTwinId, scenario_id, elementId, mission_id);
        }
        window.dispatchEvent(new CustomEvent("openGenericSimulatorConsole"));
    };

    const modal = get_modal_details('generic_simulator_console');

    return (
        <Fragment>
            <div className="right__button__container" onClick={(e: any) => e.stopPropagation()}>
                <CustomToolTip title="Console" placement="bottom">
                    <button
                        className={`right__section__button center__btn ${modal.open ? 'active' : ''}`}
                        onClick={handleOpenConsole}
                    >
                        <ConsoleSvg />
                        <PinnedSvg showPinned={modal.pinned} />
                    </button>
                </CustomToolTip>
            </div>
        </Fragment>
    );
};

export default RightContainer;
